(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabincare-sets"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('cc-set-form')) return;
    event.preventDefault();
    const button = form.querySelector('button');
    const error = form.querySelector('.cc-set-error');
    if (button.disabled) return;
    button.disabled = true;
    error.hidden = true;
    const items = Array.from(form.querySelectorAll('input[name="variant"]'), input => ({ id: input.value, quantity: 1 }));
    try {
      const response = await fetch(form.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Unable to add set');
      window.location.assign(form.dataset.root + 'cart');
    } catch {
      error.textContent = form.dataset.error;
      error.hidden = false;
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
